
import { defineComponent, ref } from 'vue';
import { FormInst } from 'naive-ui';
import { networkInventory } from '../../../common';
import GlobalNetworkIcon from '../icons/GlobalNetworkIcon.vue';
import { EthersService as eth } from '../services';

export default defineComponent({
  emits: ['cancel', 'networkSelect'],
  components: { GlobalNetworkIcon },
  setup(_, { emit }) {
    const formRef = ref<FormInst | null>(null);
    const cancel = () => {
      emit('cancel');
    };

    return {
      formRef,
      cancel,
      eth,
      networks: Object.values(networkInventory)
    };
  },
})
